module.exports = __webpack_public_path__ + "static/montserrat-v12-latin-300-0a7c6df06e85d978d096d4d18fd8d43d.woff2";